var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.7,22c-0.2,1.4-1.3,2.4-2.7,2.4c-1.4,0-2.6-1.1-2.7-2.4c-3.7,0.2-6.3,0.8-6.3,1.4c0,0.8,4,1.5,9,1.5s9-0.7,9-1.5 C23.9,22.8,21.3,22.2,17.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,23.1c0,0,0-0.1,0-0.1c0-0.4-0.2-1-0.4-1.6c-0.4-1.9-2.9-3.7-3-3.9c-1.1-3.4-1.3-6.7-1.5-8.5c-0.1-0.8-2.6-2-5.2-2 c-2.6,0-5.2,1.1-5.3,2c-0.2,1.7-0.3,5-1.4,8.5c-0.1,0.2-2.6,2-2.9,3.9C5.2,21.9,5,22.4,5,22.9c0.5-1.1,4.8-2,9.9-2 C20.5,20.8,24.9,21.8,25,23.1c-0.1,0.1-0.1,0.2-0.1,0.3C24.9,23.3,25,23.2,25,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,6.2C16.6,5.5,15.9,5,15,5c-0.8,0-1.6,0.5-2.1,1.2c0.7-0.4,1.4-0.4,2.1-0.4C15.7,5.8,16.4,5.8,17.1,6.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientAlarm);
export default __webpack_public_path__ + "static/media/client-alarm.910ba2afed4c3f1f783d937cc0ec83c2.svg";
export { ForwardRef as ReactComponent };